import { createStyles } from '@material-ui/core';

const styles = (theme) =>
  createStyles({
    dialog: {
      borderTop: '1px solid ' + theme.palette.primary.main,
      padding: '2em'
    },

    title: {
      margin: '0.4em 0'
    },

    grid: {
      display: 'grid',
      gridGap: '14px',
      marginBottom: '10px'
    },

    accept: {
      width: '100%',
      alignItems: 'center',
      justifyItems: 'center',
      display: 'flex',
      gap: '14px',
      '@media(max-width: 576px)': {
        flexDirection: 'column'
      }
    }
  });

export default styles;
